import React, { useState, useLayoutEffect, useEffect } from 'react';
import { useForm, Controller, useWatch } from "react-hook-form";

import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';

import CheckIcon from '@mui/icons-material/Check';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import UndoIcon from '@mui/icons-material/Undo';

import LoadingDialog from '../../Loading';
import useAuthAxios from "../../../useAuthAxios";
import {
    GrayButton,
    NomalButton
} from '../../css/CSS.js';


export default function AccounEditDialog(props) {

    const [open, setOpen] = useState(false)
    const [showPassword, setShowPassword] = React.useState(false);
    const [processing, setProcessing] = useState(false);
    const authAxios = useAuthAxios();

    const { control, handleSubmit, getValues, setValue, trigger, unregister, formState: { errors, isValid }, clearErrors, setError, reset } = useForm({
        defaultValues: {
            contractSei: "",
            contractMei: "",
            email: "",
            password: "",
            comparePassword: "",
            companyName: "",
            tantoShisyaCD: "",
            tellNumber: "",
            defaultPasswordUse: props.operateType === 0
        },
        mode: 'onChange'
    });
    const defaultPasswordUse = useWatch({
        control,
        name: "defaultPasswordUse",
        defaultValue: props.operateType === 0
    });



    const validationRules = {
        contractSei: {
            required: '氏名は必須です',
            validate: (value) => {
                if (value) {
                    let count = 0
                    for (let i = 0, len = value.length; i < len; i++) {
                        if (value[i].match(/^[^ -~｡-ﾟ]/)) { // 全角半角判定
                            count += 1
                        } else {
                            count += 0.5
                        }
                    }
                    if (count > 10) {
                        return "全角10文字もしくは半角20文字以内で入力してください。";
                    }
                }
            }
        },
        contractMei: {
            required: '氏名は必須です',
            validate: (value) => {
                if (value) {
                    let count = 0
                    for (let i = 0, len = value.length; i < len; i++) {
                        if (value[i].match(/^[^ -~｡-ﾟ]/)) { // 全角半角判定
                            count += 1
                        } else {
                            count += 0.5
                        }
                    }
                    if (count > 10) {
                        return "全角10文字もしくは半角20文字以内で入力してください。";
                    }
                }
            }
        },
        email: {
            required: 'メールアドレスは必須です',
            pattern: {
                value: /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/,
                message: 'XXX@XXXで入力してください。'
            }
        },
        password: defaultPasswordUse ?
            {} :
            {
                required: 'パスワードは必須です',
                pattern: {
                    value: /^[\x20-\x7E]+$/,
                    message: '全角文字は使用できません。半角文字で入力してください',
                },
                validate: (value) => {
                    if (getValues("comparePassword") !== "") {
                        if (value === getValues("comparePassword")) {
                            clearErrors("comparePassword")
                        } else {
                            setError("comparePassword", { message: "確認用パスワードが一致していません" })
                        }
                    }
                }
            }
        ,
        comparePassword: defaultPasswordUse ?
            {} :
            {
                required: '確認用パスワードは必須です',
                pattern: {
                    value: /^[\x20-\x7E]+$/,
                    message: '全角文字は使用できません。半角文字で入力してください',
                },
                validate: (value) => {
                    if (value !== getValues("password")) {
                        return '確認用パスワードが一致していません'
                    }
                    clearErrors("tenkenTimeFrom")
                }
            },
        companyName: {
            validate: (value) => {
                if (value) {
                    let count = 0
                    for (let i = 0, len = value.length; i < len; i++) {
                        if (value[i].match(/^[^ -~｡-ﾟ]/)) { // 全角半角判定
                            count += 1
                        } else {
                            count += 0.5
                        }
                    }
                    if (count > 20) {
                        return "全角20文字もしくは半角40文字以内で入力してください。";
                    }
                }
            }
        },
        tantoShisyaCD: {
            required: '担当支社は必須です',
        },
        tellNumber: {
            required: '電話番号は必須です',
            pattern: {
                value: /^[0-9-]+$/,
                message: '有効な電話番号形式（数字とハイフンのみ）で入力してください',
            },
        },
    }

    useEffect(() => {
        if (defaultPasswordUse) {
            // 無効になった瞬間にエラーをクリア
            clearErrors("password");
            clearErrors("comparePassword");
            unregister('password');
            unregister('comparePassword');
        } else {
            trigger("password");
            trigger("comparePassword");
        }
    }, [defaultPasswordUse])

    const handleClose = () => {
        setOpen(false)
        props.closeClick();
    };

    useLayoutEffect(() => {
        setOpen(props.open)
        reset({ defaultPasswordUse: props.operateType === 0 })
        if (props.operateType === 1) {
            setValue("contractSei", props.contractInfo.contractSei)
            setValue("contractMei", props.contractInfo.contractMei)
            setValue("email", props.contractInfo.email)
            setValue("password", props.contractInfo.password)
            setValue("comparePassword", "")
            setValue("companyName", props.contractInfo.companyName)
            setValue("tantoShisyaCD", props.contractInfo.tantoShisyaCD)
            setValue("tellNumber", props.contractInfo.tellNumber)
        } else {
            reset()
        }
        setShowPassword(false)
        clearErrors()
    }, [props.open])

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    const onSubmit = () => {
        trigger()
        if (!isValid) {
            return
        }
        setProcessing(true);
        const VendorPostInfoList = []
        if (props.operateType === 0) {
            if (defaultPasswordUse) {
                VendorPostInfoList.push({
                    contractSei: getValues("contractSei"),
                    contractMei: getValues("contractMei"),
                    email: getValues("email"),
                    defaultPasswordUse: 1,
                    companyName: getValues("companyName"),
                    tantoShisyaCD: getValues("tantoShisyaCD"),
                    tellNumber: getValues("tellNumber"),
                })
            } else {
                VendorPostInfoList.push({
                    contractSei: getValues("contractSei"),
                    contractMei: getValues("contractMei"),
                    email: getValues("email"),
                    password: getValues("password"),
                    companyName: getValues("companyName"),
                    tantoShisyaCD: getValues("tantoShisyaCD"),
                    tellNumber: getValues("tellNumber"),
                })
            }
        } else if (props.operateType === 1) {
            VendorPostInfoList.push({
                contractNo: props.contractInfo.contractNo,
                contractSei: getValues("contractSei"),
                contractMei: getValues("contractMei"),
                email: getValues("email"),
                password: getValues("password"),
                companyName: getValues("companyName"),
                tantoShisyaCD: getValues("tantoShisyaCD"),
                tellNumber: getValues("tellNumber"),
            })
        }
        authAxios
            .post('api/inspection/inspectionVendor', { VendorPostInfoList })
            .then(response => {
                if (response.status === 200) {
                    setOpen(false)
                    setProcessing(false);
                    if (defaultPasswordUse) {
                        alert('ログインパスワードはアカウント修正モーダルより確認してください。');
                    }
                    props.confirmClick();
                }
            })
            .catch((response) => {
                alert("登録に失敗しました。", response.body);
                setProcessing(false)
            });
    }



    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <LoadingDialog load={processing} />
            <Grid container direction="row"
                sx={{
                    justifyContent: "center",
                    alignItems: "left",
                    p: 3,
                    backgroundColor: "#1976d2",
                }}>
                {props.operateType === 0 ?
                    <DialogTitle id="alert-dialog-title" sx={{ fontSize: '1.7rem', color: '#ffffff', py: 0 }}>
                        {"請負担当者アカウント作成"}
                    </DialogTitle>
                    :
                    props.operateType === 1 ?
                        <DialogTitle id="alert-dialog-title" sx={{ fontSize: '1.7rem', color: '#ffffff', py: 0 }}>
                            {"請負担当者アカウント修正"}
                        </DialogTitle>
                        : null
                }
            </Grid>
            <form onSubmit={handleSubmit(onSubmit)} >
                <DialogContent sx={{ px: 5, py: 5 }}>
                    <Grid container
                        sx={{
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                        }}
                        spacing={2}>
                        <Grid container item spacing={2} xs={12}>
                            <Grid item xs={12} sm={6}>
                                <Controller
                                    control={control}
                                    name="contractSei"
                                    rules={validationRules.contractSei}
                                    render={({ field, fieldState }) =>
                                        <TextField
                                            {...field}
                                            variant="outlined"
                                            label="氏"
                                            sx={{ width: "100%" }}
                                            error={fieldState.invalid}
                                            inputProps={{ maxLength: 20, }}
                                            helperText={errors.contractSei?.message}
                                        />
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Controller
                                    control={control}
                                    name="contractMei"
                                    rules={validationRules.contractMei}
                                    render={({ field, fieldState }) =>
                                        <TextField
                                            {...field}
                                            variant="outlined"
                                            label="名"
                                            sx={{ width: "100%" }}
                                            error={fieldState.invalid}
                                            inputProps={{ maxLength: 20, }}
                                            helperText={errors.contractMei?.message}
                                        />
                                    }
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                control={control}
                                name="email"
                                rules={validationRules.email}
                                render={({ field, fieldState }) =>
                                    <TextField
                                        required
                                        {...field}
                                        variant="outlined"
                                        label="メールアドレス"
                                        id="email"
                                        sx={{ width: "100%" }}
                                        error={fieldState.invalid}
                                        inputProps={{ maxLength: 255, }}
                                        helperText={errors.email?.message}
                                    />
                                }
                            />
                        </Grid>
                        <Grid item xs={12}>
                            {props.operateType === 0 && (
                                <Controller
                                    name="defaultPasswordUse"
                                    control={control}
                                    render={({ field, formState: { errors } }) => (
                                        <FormGroup {...field}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        {...field}
                                                        checked={field.value}
                                                    />}
                                                label="システムデフォルトパスワード"
                                            />
                                            <FormHelperText>{errors.check?.message || ''}</FormHelperText>
                                        </FormGroup>
                                    )}
                                />
                            )}
                            <Controller
                                control={control}
                                name="password"
                                rules={validationRules.password}
                                render={({ field, fieldState }) =>
                                    <FormControl
                                        variant="outlined"
                                        sx={{ width: "100%" }}
                                        disabled={defaultPasswordUse}
                                    >
                                        <InputLabel htmlFor="outlined-adornment-password" required={!defaultPasswordUse}>パスワード</InputLabel>
                                        <OutlinedInput
                                            required={!defaultPasswordUse}
                                            {...field}
                                            type={showPassword ? 'text' : 'password'}
                                            variant="outlined"
                                            label="パスワード"
                                            sx={{
                                                width: "100%",
                                                "& input[type=password]::-ms-reveal": { display: "none", width: 0, height: 0 },
                                                "& input[type=password]::-ms-clear": { display: "none", width: 0, height: 0 },
                                                "&.Mui-disabled": {
                                                    backgroundColor: (theme) =>
                                                        theme.palette.mode === "light"
                                                            ? theme.palette.action.disabledBackground
                                                            : theme.palette.action.disabled,
                                                },
                                                '&.Mui-disabled *': {
                                                    cursor: "not-allowed"
                                                }
                                            }}
                                            error={fieldState.invalid}
                                            inputProps={{ maxLength: 20, }}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        onMouseUp={handleMouseUpPassword}>
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                        <FormHelperText error>{fieldState.error?.message}</FormHelperText>
                                    </FormControl>
                                }
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                key={defaultPasswordUse ? 'pw_off' : 'pw_on'} 
                                control={control}
                                name="comparePassword"
                                rules={validationRules.comparePassword}
                                render={({ field, fieldState }) =>
                                    <FormControl
                                        variant="outlined"
                                        sx={{ width: "100%" }}
                                        disabled={defaultPasswordUse}
                                    >
                                        <InputLabel htmlFor="outlined-adornment-password" required={!defaultPasswordUse}>確認用パスワード</InputLabel>
                                        <OutlinedInput
                                            required={!defaultPasswordUse}
                                            {...field}
                                            type={showPassword ? 'text' : 'password'}
                                            variant="outlined"
                                            label="確認用パスワード"
                                            sx={{
                                                width: "100%",
                                                "& input[type=password]::-ms-reveal": { display: "none", width: 0, height: 0 },
                                                "& input[type=password]::-ms-clear": { display: "none", width: 0, height: 0 },
                                                "&.Mui-disabled": {
                                                    backgroundColor: (theme) =>
                                                        theme.palette.mode === "light"
                                                            ? theme.palette.action.disabledBackground
                                                            : theme.palette.action.disabled,
                                                },
                                                '&.Mui-disabled *': {
                                                    cursor: "not-allowed"
                                                }
                                            }}
                                            error={fieldState.invalid}
                                            inputProps={{ maxLength: 20, }}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton onClick={handleClickShowPassword}>
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                        <FormHelperText error>{fieldState.error?.message}</FormHelperText>
                                    </FormControl>

                                }
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                control={control}
                                name="companyName"
                                rules={validationRules.companyName}
                                render={({ field, fieldState }) =>
                                    <TextField
                                        {...field}
                                        variant="outlined"
                                        label="会社名(任意)"
                                        sx={{ width: "100%" }}
                                        error={fieldState.invalid}
                                        inputProps={{ maxLength: 40, }}
                                        helperText={errors.companyName?.message}
                                    />
                                }
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                control={control}
                                name="tantoShisyaCD"
                                rules={validationRules.tantoShisyaCD}
                                render={({ field, fieldState }) => (
                                    <FormControl error={fieldState.invalid}
                                        sx={{ width: "100%" }} >
                                        <InputLabel id="area-label" required>担当支社</InputLabel>
                                        <Select
                                            required
                                            labelId="shiten-label"
                                            label="担当支社"
                                            variant="outlined"
                                            defaultValue=""
                                            sx={{ width: "100%" }}
                                            {...field}
                                        >
                                            {props?.shitenList?.map((row, index) => {
                                                return (
                                                    <MenuItem key={index} value={row.shitenCD}>{row.shitenName}</MenuItem>
                                                );
                                            })}
                                        </Select>
                                        <FormHelperText>{fieldState.error?.message}</FormHelperText>
                                    </FormControl>
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                control={control}
                                name="tellNumber"
                                rules={validationRules.tellNumber}
                                render={({ field, fieldState }) =>
                                    <TextField
                                        required
                                        {...field}
                                        variant="outlined"
                                        label="電話番号"
                                        sx={{ width: "100%" }}
                                        error={fieldState.invalid}
                                        inputProps={{ maxLength: 15, }}
                                        helperText={errors.tellNumber?.message}
                                    />
                                }
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
            </form>
            <DialogActions>
                <Grid container
                    sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 2
                    }}>
                    <GrayButton variant="contained" size="large" onClick={handleClose}
                        sx={{ ml: 2, mr: 2, pt: 1, pb: 1, pl: 2, pr: 3, fontSize: '1.2rem' }} >
                        <UndoIcon sx={{ mr: 2, fontSize: '2rem' }} />
                        戻る
                    </GrayButton>
                    <NomalButton variant="contained" size="large" onClick={onSubmit}
                        sx={{ ml: 2, mr: 2, pt: 1, pb: 1, pl: 2, pr: 3, fontSize: '1.2rem' }} >
                        <CheckIcon sx={{ mr: 2, fontSize: '2rem' }} />確定
                    </NomalButton>
                </Grid>
            </DialogActions>
        </Dialog>
    );
}